module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo-login.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "push-50-t"
  }, [_vm._v(_vm._s(_vm.labelFieldTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "alert push-30-t alert-danger alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (!_vm.registerSuccess) ? _c('form', {
    staticClass: "simple_form form-horizontal push-50-t"
  }, [_c('div', {
    staticClass: "form-inputs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.lastName),
      expression: "userInfos.lastName"
    }],
    staticClass: "form-control string text optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "autofocus": "autofocus",
      "type": "text",
      "value": "",
      "id": "user_lastName"
    },
    domProps: {
      "value": (_vm.userInfos.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_lastName"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldName[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.name),
      expression: "userInfos.name"
    }],
    staticClass: "form-control string text optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "autofocus": "autofocus",
      "type": "text",
      "value": "",
      "id": "user_name"
    },
    domProps: {
      "value": (_vm.userInfos.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_name"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldFirstName[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.email),
      expression: "userInfos.email"
    }],
    staticClass: "form-control string email optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "type": "email",
      "value": "",
      "id": "user_email"
    },
    domProps: {
      "value": (_vm.userInfos.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_email"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEmail[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.password),
      expression: "userInfos.password"
    }],
    staticClass: "form-control password optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "type": "password",
      "name": "user[password]",
      "id": "user_password"
    },
    domProps: {
      "value": (_vm.userInfos.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_password"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldPW[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.repassword),
      expression: "userInfos.repassword"
    }],
    staticClass: "form-control password optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "type": "password",
      "name": "user[password]",
      "id": "user_repassword"
    },
    domProps: {
      "value": (_vm.userInfos.repassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "repassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_repassword"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldConfirmPW[_vm.actualLanguage]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [(!_vm.isRegistering) ? _c('button', {
    staticClass: "btn btn-connexion btn-success",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonSubscribe[_vm.actualLanguage]))]) : _c('spinner')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.labelFieldAlready[_vm.actualLanguage]) + "\n                "), _c('router-link', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.labelFieldButtonLogIn[_vm.actualLanguage]) + "\n                ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [_c('button', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleLanguage
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonLanguage[_vm.actualLanguage]))])])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac4c8684","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/session/Register.vue
// module id = 1579
// module chunks = 4